import { TOrbit } from '../../../i18n/TModules';
import {
  DEFAULT_STAMP_SLOT,
  LimitPeriod,
  MAX_STAMP_SLOTS,
  StampPrize,
  WizardState
} from '../wizardModel';
import { CampaignFormValues } from '../wizardSubmission';
import {
  AdapterContext,
  baseValues,
  intervalValues,
  limitValue,
  prizeComplete,
  toOutcome
} from './common';
import { toCampaignRule, toSavedRule, Translate } from './ruleAdapter';

const TP = `${TOrbit}.wizard.prize`;

// The stamp card's per-user period keeps the module's plural `weeks` (`StampCampaign`).
const STAMP_PERIOD: Record<LimitPeriod, string> = {
  day: 'day',
  week: 'weeks',
  month: 'month',
  year: 'year'
};

/** The card is as long as its last prize, and never shorter than the FR's 8 stamps. */
export const totalStamps = (prizes: StampPrize[]): number =>
  Math.max(DEFAULT_STAMP_SLOT, ...prizes.map(prize => prize.slot));

export const stampPrizeErrors = (prizes: StampPrize[], t: Translate): string[] => {
  const errors: string[] = [];
  const slots = prizes.map(prize => prize.slot);
  if (prizes.some(prize => !prizeComplete(prize))) {
    errors.push(t(`${TP}.incomplete`));
  }
  if (new Set(slots).size !== slots.length) {
    errors.push(t(`${TP}.slotTaken`));
  }
  if (slots.some(slot => slot < 1 || slot > MAX_STAMP_SLOTS)) {
    errors.push(t(`${TP}.slotRange`, { max: MAX_STAMP_SLOTS }));
  }
  return errors;
};

export const stampValues = (state: WizardState, context: AdapterContext): CampaignFormValues => {
  const { limits } = state;
  return {
    ...baseValues(state, 'stamp', context, false),
    total_stamps: totalStamps(state.prizes),
    rules: state.triggers
      .slice(0, 1)
      .map(trigger => toSavedRule(toCampaignRule(trigger, 'stamp', context.t))),
    outcomes: state.prizes.map(prize => ({ ...toOutcome(prize), position: prize.slot })),
    campaign_lifetime_max_cards_available: limitValue(limits.totalOn, limits.total),
    account_lifetime_max_cards_available: limitValue(limits.perUserOn, limits.perUser),
    ...intervalValues(
      'account',
      'account_interval_max_stamps_available',
      limits.userRateOn,
      limits.userRate,
      STAMP_PERIOD[limits.userRatePeriod]
    )
  };
};
